import { render, staticRenderFns } from "./MyUserPwd.vue?vue&type=template&id=713c9a26&"
import script from "./MyUserPwd.vue?vue&type=script&lang=js&"
export * from "./MyUserPwd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports